import React from "react"
import TrialMarketoForm from "./TrialMarketoForm"
import { TrialSummary } from "trimble-terra"
import "./EntitlementsForm.scss"

const EntitlementsForm = ({
  trialSummary,
  marketoForm,
  appData,
  userInfo,
  productData,
  startTrial,
  setLoading,
  setError,
  setErrorText,
  loading,
  submitToWorkato
}) => {
  const defaultMktoInstance = {
    munchkinId: "748-IYT-379",
    formScriptSource: "//go.trimble.com",
    compoundKeys: false,
    thankYou: { childMarkdownRemark: { html: "<p>Thanks!</p>" } },
  }
  return (
    <section className="entitlement-form-container">
      <div className="entitlement-form-container__content-area">
        <TrialMarketoForm
          formId={marketoForm?.marketoFormId || "1038"}
          marketoInstance={marketoForm?.marketoInstance || defaultMktoInstance}
          fieldDefaults={marketoForm?.fieldDefaults}
          variant={marketoForm?.variant || "light"}
          header={marketoForm?.formHeader || "Start Your Trial"}
          directions={marketoForm?.formDirections?.formDirections}
          sideImage={marketoForm?.formImage}
          eyebrow={marketoForm?.eyebrow}
          product={marketoForm?.product}
          removePadding={marketoForm?.removePadding}
          inLayoutWrapper={true}
          trialPage
          userInfo={userInfo}
          productData={productData}
          startTrial={startTrial}
          setLoading={setLoading}
          setError={setError}
          setErrorText={setErrorText}
          loading={loading}
          submitToWorkato={submitToWorkato}
        />
        {trialSummary && <TrialSummary content={trialSummary} />}
      </div>
    </section>
  )
}

export default EntitlementsForm
